module.exports = __webpack_public_path__ + "img/icon-arrow-w.df362b93.svg";